import {
  generateSPSCategoryManufacturerURL,
  generateSPSManufacturerURL,
  nonAlphaNumCharReplacement,
} from '@/shared/utils/URLs';

type Category = {
  id: number;
  name: string;
};

export const getSPSCategoryURL = (category: Category) => {
  return `/search/category/${nonAlphaNumCharReplacement(
    category.name.toLowerCase(),
  )}/${category.id}`;
};

type Manufacturer = {
  id: number;
  name: string;
};
export const getSPSManufacturerURL = (manufacturer: Manufacturer) => {
  return generateSPSManufacturerURL(manufacturer.name, manufacturer.id);
};

type CategoryManufacturer = {
  category: Category;
  manufacturer: Manufacturer;
};
export const getSPSCategoryManufacturerURL = ({
  category,
  manufacturer,
}: CategoryManufacturer) => {
  return generateSPSCategoryManufacturerURL(
    category.name,
    category.id,
    manufacturer.name,
    manufacturer.id,
  );
};
